import { render, staticRenderFns } from "./ModalUserdata.vue?vue&type=template&id=b4a8619a&scoped=true"
import script from "./ModalUserdata.vue?vue&type=script&lang=js"
export * from "./ModalUserdata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a8619a",
  null
  
)

export default component.exports